/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExportForEntityRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ExportForEntityResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const exportData = (request:ExportForEntityRequest, options?: CashRequestOptions) => post<ExportForEntityRequest, ExportForEntityResponse>("/2.0/cash/export-data", request, {...options, rejectOnError: true })